import config from "./config";

export const GLOBALS: Config = config;
